<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-columns">
        <div class="footer-column logo-column">
          <div class="logo-area">
            <h3>Go Coin <span>Identifier</span></h3>
            <div class="logo-underline"></div>
          </div>
          <p class="company-desc">Advanced coin recognition system based on deep learning, quickly and accurately identifying coins from around the world</p>
        </div>
        
        <div class="footer-column nav-column">
          <h4>Quick Navigation</h4>
          <nav class="footer-nav">
            <a href="#">Home</a>
            <a href="#features">Features</a>
            <a href="#tech">Technology</a>
            <a href="#use-cases">Use Cases</a>
          </nav>
        </div>
        
        <div class="footer-column contact-column">
          <h4>Contact Us</h4>
          <div class="contact-item">
            <div class="contact-icon">
              <span>✉️</span>
            </div>
            <a href="mailto:sl9283191@gmail.com">sl9283191@gmail.com</a>
          </div>
        </div>
      </div>

      <div class="footer-divider"></div>
      
      <div class="footer-bottom">
        <div class="copyright">
          <p>Copyright © 2024 All rights reserved</p>
        </div>
        <div class="footer-policy-links">
          <a href="https://gocoinidentifier.com/privacy">Privacy Policy</a>
          <span class="link-divider">|</span>
          <a href="https://gocoinidentifier.com/term">Terms of Use</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background-color: #1a1a2e;
  color: rgba(255, 255, 255, 0.8);
  padding: 60px 0 20px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

.footer-columns {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 50px;
}

.footer-column {
  padding: 0 15px;
}

.logo-column {
  grid-column: 1;
}

.nav-column {
  grid-column: 2;
  text-align: left;
  padding-left: 0;
  padding-right: 40px;
}

.contact-column {
  grid-column: 3;
  text-align: left;
  padding-right: 0;
  padding-left: 0;
}

.logo-area h3 {
  font-size: 26px;
  color: #fff;
  margin: 0 0 10px;
  font-weight: 700;
}

.logo-area span {
  color: #ffd700;
}

.logo-underline {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #ffd700, rgba(255, 215, 0, 0.3));
  margin-bottom: 20px;
  border-radius: 3px;
}

.company-desc {
  font-size: 16px;
  line-height: 1.8;
  margin: 0;
  opacity: 0.9;
  max-width: 400px;
}

.footer-column h4 {
  color: #fff;
  font-size: 18px;
  margin: 0 0 25px;
  position: relative;
  font-weight: 600;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(255, 215, 0, 0.3);
  display: inline-block;
}

.footer-nav {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 150px;
  margin: 0;
}

.footer-nav a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  margin-bottom: 12px;
  transition: all 0.3s;
  position: relative;
  display: inline-block;
  text-align: left;
  padding: 0 0 0 0;
}

.footer-nav a::before {
  display: none;
}

.footer-nav a:hover {
  color: #ffd700;
  transform: translateX(5px);
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: flex-start;
}

.contact-icon {
  width: 28px;
  height: 28px;
  background-color: rgba(255, 215, 0, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  margin-left: 0;
}

.contact-icon span {
  font-size: 14px;
}

.contact-item a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;
}

.contact-item a:hover {
  color: #ffd700;
}

.footer-divider {
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin-bottom: 20px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.copyright p {
  font-size: 13px;
  margin: 0;
  opacity: 0.7;
}

.footer-policy-links {
  display: flex;
  align-items: center;
}

.footer-policy-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.footer-policy-links a:hover {
  color: #ffd700;
}

.link-divider {
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.3);
}

@media (max-width: 900px) {
  .footer-columns {
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 50px 0 20px;
  }
  
  .footer-columns {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .logo-column, .nav-column, .contact-column {
    grid-column: 1;
    text-align: center;
    margin-bottom: 0;
    padding-left: 15px;
    padding-right: 15px;
  }
  
  .footer-nav {
    align-items: center;
    margin: 0 auto;
  }
  
  .footer-nav a {
    padding: 0;
    text-align: center;
  }
  
  .footer-nav a::before {
    display: none;
  }
  
  .contact-item {
    justify-content: center;
  }
  
  .logo-underline {
    margin: 0 auto 20px;
  }
  
  .company-desc {
    max-width: 100%;
    text-align: center;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 15px;
  }
  
  .copyright {
    text-align: center;
  }
  
  .footer-policy-links {
    justify-content: center;
  }
}
</style> 